import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAuth } from "../components/AuthContext/AuthContext";
import { Primary } from "../stories/Buttons/Button.stories";
import logo from "../assets/images/boots-myhealthchecked-logo.svg";
import LoggedOutLayout from "../stories/LoggedOutScreens/LoggedOutLayout";
import Vector from "../assets/icons/Vector.svg";
import InformationFill from "../assets/icons/Information-fill.svg";
import useApis from "../services/useAPI";
import { forgotPasswordUrl } from "../utils/constants";
import { CheckCircleFill } from 'react-bootstrap-icons';

import VHConfirmationPopup from "../stories/Modals/VHConfirmationPopup";

function EmailConfirmation() {
  const auth = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const { callApi, isLoading, message, serverError } = useApis(
    forgotPasswordUrl,
    "POST",
  );

  const handleResendEmail = async (e) => {
    e?.preventDefault();

    const email = auth.email || location.state?.email;

    if (!email || isLoading) return;

    const payload = {
      email: email.toLowerCase(),
    };

    await callApi(payload);
    auth.showToast("Success", 'Please check your inbox, an email has been sent to you!',undefined,{icon: <CheckCircleFill />,className: auth?.featureFlag && "vh-toaster"})
  
  };

  useEffect(() => {
    auth.setTitle(
      auth?.featureFlag ? "Please check your email" : "Please check your inbox",
    );
  }, [auth.title, auth?.featureFlag]);

  useEffect(() => {
    if (!location.state?.email && !auth.email) {
      navigate("/login", { replace: true });
    }
  }, [location, auth.email, navigate]);

  const oldContent = (
    <>
      <p>
        Instructions for resetting your password have been sent to{" "}
        {`${auth.email || location.state?.email}`}. Please follow the steps
        outlined in the email to create a new password.{" "}
        <span className="ageo-medium">
          For your security, the link will only be valid for 1 hour.
        </span>{" "}
      </p>
      <p>
        For further questions, please contact us at{" "}
        <a href="mailto:care@myhealthchecked.com">care@myhealthchecked.com</a>
      </p>
      <div className="form-group">
        <Primary
          onClick={() => navigate("/login")}
          label={"Back to Login"}
          className="close-window"
        />
      </div>
    </>
  );

  return (
    <LoggedOutLayout
      className={
        auth?.featureFlag
          ? "vh-forgot-password-confirmation"
          : auth.title === "Access dashboard"
          ? "login-bg login-page-container "
          : ""
      }
      logoSrc={logo}
      hideLogo={auth?.featureFlag}
      title={auth?.featureFlag ? "" : auth.title}
    >
      {auth?.featureFlag ? (
        <VHConfirmationPopup
          title="Please check your email"
          message="We've sent password reset instructions to your registered email address. Please check your inbox and follow the link to reset your password."
          infoText="If you don't receive the email within a few minutes, please check your spam or junk folder."
          primaryLabel="Back to login"
          primaryHref="/login"
          secondaryLabel="Resend email"
          onSecondaryClick={handleResendEmail}
        />
      ) : (
        oldContent
      )}
    </LoggedOutLayout>
  );
}

export default EmailConfirmation;
